// extracted by mini-css-extract-plugin
export var colourBase = "qdtMHA0_YsHleoeXdU3I";
export var colourDisabled = "oWlCVzL_HJaLweCvQhAE";
export var colourInverted = "p04yU4jfT1HQhEgKvEhh";
export var colourNegative = "D9VWuVCpn_M17EphxgTD";
export var colourPositive = "HcEfZ3rsMy9FhZXQQcM9";
export var colourSubdued = "P6aVoAxCGb6j4kmE2yD_";
export var colourSubtle = "tQ2T7U79Y0GPVkW2XdLQ";
export var colourUrgencyHigh = "o9FhwYtvOYaBzC4Ik0tr";
export var colourUrgencyMedium = "ib_mp4gANKTYoSY0hYTm";
export var colourWarning = "lCxL6PwjQfsWtu7fSLEp";
export var colourWhite = "yNDwslTC5O4aBTjfaSXQ";